"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _logger = require("../../logger");
var _models = require("../../models");
var _shared = require("../shared");
var _PickupPointsListPage = require("./PickupPointsListPage");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react-hooks/rules-of-hooks -- False positives? */

const ListContainer = (0, _mui.styled)('div')({
  ..._shared.scrollingContainerStyles,
  display: 'flex',
  flexDirection: 'column'
});
const componentName = 'PickupPointsList.tsx';

/**
 * @obsolete Can be dropped later when flat selection UI is used in all markets
 * and/or the merged map & list UI switch is enabled everywhere.
 */
const PickupPointsList = pickupPointsListProps => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    currentListPage,
    searchTerm,
    setActiveFilter,
    setCurrentListPage
  } = pickupPointsListProps;
  function onFilterChange(filterName) {
    setActiveFilter(filterName);
    setCurrentListPage(0);
  }
  const showMorePickupPoints = (0, _react.useCallback)(() => {
    (0, _logger.logInfo)(`${componentName}: Load more pickup points action was triggered.\n \n `);
    setCurrentListPage(prevState => prevState + 1);
  }, [setCurrentListPage]);
  (0, _react.useEffect)(() => {
    if (!searchTerm && currentListPage) {
      setCurrentListPage(0);
    }
  }, [currentListPage, searchTerm, setCurrentListPage]);
  const pickupPointsListPages = [];
  for (let i = 0; i <= currentListPage; i++) {
    const pageKey = `pickup-points-list-page-${i}`;
    pickupPointsListPages.push({
      pageKey,
      onFilterChange,
      pageNumber: i,
      showMorePickupPoints,
      ...pickupPointsListProps
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ListContainer, {
    "data-testid": getTestId(_models.TestId.PickupPointsListContainer),
    children: pickupPointsListPages.map(props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_PickupPointsListPage.PickupPointsListPage, {
      ...props
    }, props.pageKey))
  });
};
var _default = exports.default = PickupPointsList;